/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const TrackingCheckResultDTOTrackingCheckStatusEnum = {
    NoTracking: 'NO_TRACKING',
    Match: 'MATCH',
    Mismatch: 'MISMATCH'
};
/**
 * Check if a given object implements the TrackingCheckResultDTO interface.
 */
export function instanceOfTrackingCheckResultDTO(value) {
    return true;
}
export function TrackingCheckResultDTOFromJSON(json) {
    return TrackingCheckResultDTOFromJSONTyped(json, false);
}
export function TrackingCheckResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'amazonTrackingNumbers': json['amazonTrackingNumbers'] == null ? undefined : json['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': json['shippinglotTrackingNumber'] == null ? undefined : json['shippinglotTrackingNumber'],
        'trackingCheckStatus': json['trackingCheckStatus'] == null ? undefined : json['trackingCheckStatus'],
        'trackingCheckedAt': json['trackingCheckedAt'] == null ? undefined : (new Date(json['trackingCheckedAt'])),
        'trackingCheckError': json['trackingCheckError'] == null ? undefined : json['trackingCheckError'],
    };
}
export function TrackingCheckResultDTOToJSON(json) {
    return TrackingCheckResultDTOToJSONTyped(json, false);
}
export function TrackingCheckResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehousePackageId': value['warehousePackageId'],
        'trackingNumber': value['trackingNumber'],
        'amazonTrackingNumbers': value['amazonTrackingNumbers'],
        'shippinglotTrackingNumber': value['shippinglotTrackingNumber'],
        'trackingCheckStatus': value['trackingCheckStatus'],
        'trackingCheckedAt': value['trackingCheckedAt'] == null ? undefined : ((value['trackingCheckedAt']).toISOString()),
        'trackingCheckError': value['trackingCheckError'],
    };
}
